import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { DatePicker, message, Pagination, TableColumnsType, Typography } from "antd";
import { get as _get, debounce } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "~/Components";
import { EmailTemplate } from "~/Components/Modal/EmailTemplate";
import { TableDrawer } from "~/Components/TableDrawer/TableDrawer";
import { eramanBEApi } from "~/Services";
import ActionDropdown, { TypeData } from "~/Utils/ActionDropdown";
import { decodeHTML } from "~/Utils/CommonUtils";
import { drilldownData, ModuleConfig } from "~/Utils/drilldownData";
import { renderDateColumn } from "~/Utils/TableRenderFunction";
import { fields } from "../constants";
import { useEnquiriesDocumentDetails } from "./Enquiries.hook";
const { RangePicker } = DatePicker;

export const Enquiries = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [searchString, setSearchString] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [data, setData] = useState<any>([]);
  const [sortOrder, setSortOrder] = useState<string>("desc");
  const [orderByName, setOrderByName] = useState<string>("submittedAt");
  const [selectedEnquiryType, setSelectedEnquiryType] = useState<any>("");
  const [startDateType, setStartDateType] = useState<any>("");
  const [endDateType, setEndDateType] = useState<any>("");
  const [id, setId] = useState<string | undefined>(selectedRowData?.id);
  const [pageSize, setPageSize] = useState<number>(10);
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const enquiryType: TypeData[] = [
    // {
    //     label: 'All',
    //     value: 'All'
    // },
    {
      label: "General Enquiry",
      value: "General Enquiry",
    },
    // {
    //   label: 'Employment',
    //   value: 'Employment'
    // },
    {
      label: "Feedback",
      value: "Feedback",
    },
    // {
    //   label: 'Advertising Opportunities',
    //   value: 'Advertising Opportunities'
    // },
  ];

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchDocument,
  } = useEnquiriesDocumentDetails(id || "");

  console.log("drilldown", drilldown);

  useEffect(() => {
    if (id) {
      refetchDocument();
    }
  }, [id]);

  const membersFormConfig = useMemo(
    () => ({
      initialValues: {
        emailAddress: decodeHTML(drilldown?.email || ""),
        emailMessage: decodeHTML(""),
        emailSubject: decodeHTML(
          drilldown?.category === "General Enquiry" ? "Reply to General Enquiry" : "Reply to Feedback"
        ),
      },
      fields: fields.enquiriesEmailTemplate,
    }),
    [drilldown, selectedRowData]
  );

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
    setCurrentPage(1);
  }, 1000);

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, currentPage);
  }, [
    query?.get("activeTab"),
    selectedEnquiryType,
    startDateType,
    endDateType,
    searchString,
    sortOrder,
    orderByName,
    searchString,
    currentPage,
    pageSize,
    drawerVisible,
  ]);

  useEffect(() => {
    setId(selectedRowData?.id);
  }, [selectedRowData]);

  const getRecords = (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    setIsLoading(true);
    let url = `/admin/enquiries?pageNo=${currentPage}&pageSize=${pageSize || 10}&sortBy=${orderByParam ? orderByParam : ""}&sortOrder=${sortOrder ? sortOrder : ""}&enquiryType=${selectedEnquiryType ? selectedEnquiryType : ""}&startDate=${startDateType ? startDateType : ""}&endDate=${endDateType ? endDateType : ""}&search=${searchString}`;
    eramanBEApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data.data;
          setTotalRecords(res.data.totalRows);
          console.log("envelopes", envelopes);
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        setIsLoading(false);
      });
  };

  const columns: TableColumnsType = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "name"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "name"
            ? "descend"
            : undefined,
    },
    {
      title: "Enquiry Type",
      dataIndex: "category",
      key: "category",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "category"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "category"
            ? "descend"
            : undefined,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Submitted At",
      dataIndex: "submittedAt",
      key: "submittedAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "submittedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "submittedAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Viewed At",
      dataIndex: "viewedAt",
      key: "viewedAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "viewedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "viewedAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Replied At",
      dataIndex: "repliedAt",
      key: "repliedAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "repliedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "repliedAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (record: any, _: any) => {
        console.log("recordddddddddd", record, _);
        return (
          <div className="relative inline-block">
            <Icon
              height={25}
              icon={"iconamoon:eye"}
              className="text-blue-600 border border-blue-600 rounded-full p-0.5"
              onClick={(e) => {
                e.preventDefault();
                setSelectedRowData?.(record);
                setDrawerVisible?.(true);
              }}
            />
            {!_?.viewedAt && <span className="absolute top-0 right-0 block w-2.5 h-2.5 bg-red-500 rounded-full" />}
          </div>
        );
      },
    },
  ];

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    setCurrentPage(1);
    // getRecords(order, column.dataIndex, searchString, currentPage);
  };

  const handleEmailSubmit = async (values: Record<string, any>) => {
    console.log("Email sent: /enquiries/reply", values);
    try {
      const response = await eramanBEApi.put(`/admin/enquiries/reply`, {
        ...values,
        id: selectedRowData?.id,
      });
      if (response.status === 200) {
        message.success("Email reply sent successfully");
        setEmailModalVisible(false);
        setDrawerVisible(false);
      }
    } catch (error) {
      console.error("Error sending email reply:", error);
      message.error("Failed to send email reply");
    }
  };

  const handleEnquiryTypeChange = (value: any) => {
    setSelectedEnquiryType(value);
    setCurrentPage(1);
  };

  const handleDateRangeChange = (dates: any, dateStrings: [string, string]) => {
    const [start, end] = dateStrings;
    setStartDateType(start ? moment(start).format("YYYY-MM-DD") : "");
    setEndDateType(end ? moment(end).format("YYYY-MM-DD") : "");
    setCurrentPage(1);
  };

  return (
    <>
      <DataTable
        tabOffset={60}
        columns={columns.map((col: any) => ({
          ...col,
          onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
        }))}
        className="table-clickable"
        tableData={
          data
            ? data?.map((d: any) => {
                return {
                  ...d,
                };
              })
            : []
        }
        isLoading={isLoading}
        exportFileName="CONTRACT"
        isPagination={true}
        recordsPerPage={10}
        multiSelect={false}
        hideExport={true}
        isServerSearchApi={true}
        searchPlaceholderText={"Search by Name & Email"}
        onSearchChange={handleSearchChange}
        onClick={(record) => {
          setSelectedRowData(record);
        }}
        additionalCTA={
          <div className="flex items-center space-x-2">
            <RangePicker
              value={[startDateType ? moment(startDateType) : null, endDateType ? moment(endDateType) : null]}
              onChange={handleDateRangeChange}
              format="YYYY-MM-DD"
              placeholder={["Select Start Date", "Select End Date"]}
              className="mr-2 w-80"
              onKeyDown={(e) => e.preventDefault()}
            />
            {/* <DatePicker
                  value={startDateType ? moment(startDateType) : null}
                  onChange={(date, dateString) => {
                    const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
                    setStartDateType(formattedDate);
                  }}
                  placeholder="Select DOV"
                  className="mr-2"
                />
                <DatePicker
                  value={endDateType ? moment(endDateType) : null}
                  onChange={(date, dateString) => {
                    const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
                    setEndDateType(formattedDate);
                  }}
                  placeholder="Select CreatedOn"
                  className="mr-2"
                /> */}
            <ActionDropdown
              value={selectedEnquiryType}
              options={enquiryType}
              onChange={handleEnquiryTypeChange}
              placeholder="Select Enquiry Type"
              className="w-48"
            />
          </div>
        }
      />
      <div className="pagination">
        <Pagination
          defaultCurrent={1}
          current={currentPage}
          total={totalRecords}
          onChange={(curPage) => {
            let page = curPage;
            setCurrentPage(page);
            // getRecords(sortOrder, orderByName, searchString, page);
          }}
          showSizeChanger={true}
          onShowSizeChange={(current, size) => {
            setPageSize(size);
            setCurrentPage(current);
          }}
        />
      </div>

      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        fields={drilldownData[_get(drilldown, "subModule", "enquiries") as ModuleConfig]}
        data={drilldown}
        actions={[
          {
            label: "Reply",
            type: "primary",
            disabled: !!drilldown?.replyMessage,
            onClick: () => {},
          },
        ]}
        onReplyClick={() => setEmailModalVisible(true)}
      />

      <EmailTemplate
        visible={emailModalVisible}
        onClose={() => setEmailModalVisible(false)}
        recipientEmail={selectedRowData?.email || ""}
        onSubmit={handleEmailSubmit}
        subjectContent="Testing for string"
        title="Ready to Enquiry"
        formConfig={membersFormConfig}
      />
    </>
  );
};
